import { VerticalType } from '../../../types/cmsTypes';
import { buildDefaultSections } from './buildDefaultSections';
import { buildPersonalLoansSections } from './buildPersonalLoansSections';
import { buildStkBkaSections } from './buildStkBkaSections';
import { buildTravelInsuranceSections } from './buildTravelInsuranceSections';
import { SectionBuilder } from './types';

/**
 * Verticals with sections (or a nav) of their own. This is the only place the Product Details
 * module looks at the vertical: a vertical that needs different sections gets a builder file and a
 * line here, and its own section components — the shared components carry no vertical branches.
 */
const SECTION_BUILDERS: Partial<Record<VerticalType, SectionBuilder>> = {
  PERSONAL_LOANS: buildPersonalLoansSections,
  TRAVEL_INSURANCE: buildTravelInsuranceSections,
  INVESTMENTS: buildStkBkaSections,
  BANKING: buildStkBkaSections,
};

/** The vertical's builder; CC and every vertical without its own (or no vertical) get the default one. */
export const getSectionBuilder = (vertical?: VerticalType): SectionBuilder =>
  (vertical && SECTION_BUILDERS[vertical]) || buildDefaultSections;
